import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { adminGuard } from './guards/admin.guard';
import { authGuard } from './guards/auth.guard';

const routes: Routes = [
  {path: 'login', component: LoginComponent },
  {path: 'logout', component: LogoutComponent },
  {path: 'forbidden', component: ForbiddenComponent },
  {
    path: 'statistieken', 
    component: StatisticsComponent, 
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'producten',
    loadChildren: () => import('./modules/products/products.module').then(m => m.ProductsModule),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'opdrachten',
    loadChildren: () => import('./modules/jobs/jobs.module').then(m => m.JobsModule),
    canActivate: [authGuard]
  },
  {
    path: 'configuratie',
    loadChildren: () => import('./modules/configuration/configuration.module').then(m => m.ConfigurationModule),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'gebruikers',
    loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule),
    canActivate: [authGuard]
  },
  {
    path: 'adresboek',
    loadChildren: () => import('./modules/contact/contact.module').then(m => m.ContactModule),
    canActivate: [authGuard]
  },
  {
    path: 'facturen',
    loadChildren: () => import('./modules/invoice/invoice.module').then(m => m.InvoiceModule),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'creditnotas',
    loadChildren: () => import('./modules/credit-note/credit-note.module').then(m => m.CreditNoteModule),
    canActivate: [authGuard, adminGuard]
  },
  { path: '**', redirectTo: 'opdrachten' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {bindToComponentInputs: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
